export const settings = {
    searchApiUrl: "infodevsearchapi.leumit.co.il",
    doctorSearchResults: "/doctorssearch/doctorssearchresults",
    doctorPage: "/doctorssearch/doctorssearchresults/doctor",
    dietSearchResults: "/dietssearch/dietssearchresults",
    dietPage: "",
    socialWorkerSearchResults: "",
    socialWorkerPage: "",
    medicalCenterSearchResults: "",
    medicalCenterPage: "/medicalcentersearch/medicalcentersearchresults/medicalcenter",
    emergencySearchResults: "",
    emergencyPage: "/emergencysearch/emergencysearchresults/emergency",
    womenEmergencySearchResults: "",
    womenEmergencyPage: "",
    pharmacySearchResults: "",
    pharmacyPage: "/pharmacysearch/pharmacysearchresults/pharmacy",
    opticaSearchResults: "",
    opticaPage: "/opticasearch/opticasearchresults/optica",
    dentalSearchResults: "",
    dentalPage: "",
    outerServiceSearchResults: "",
    outerServicePage: "",
    operationsSearchResults: "/operationssearch/operationsearchresults",
    zakautServicePage: "/zakautlobby/servicepage",
    zakautSubLobbyServicePage: "",
    globalSearchResults: "/doctorssearch/globalsearchresults",
    medicienceSearchResults: "/medicinesearch/",
    showAdvanceSearch: false,
    onlineDomain: "",
    mokedPhone: "*507",
}